/**
 * HubSpot 配置常量
 * copy from http://git.patsnap.com/core-product/frontend/f-eureka/blob/Rel-25.10/packages/shared/clue-report/src/constants/index.ts
 */
export const HUBSPOT_CONFIG = {
    /** HubSpot Portal ID */
    PORTAL_ID: '2149185',

    /** HubSpot Form ID */
    FORM_ID: '7ce987ce-49e6-475d-9fcf-653d392c131d',

    /** HubSpot Region */
    REGION: 'na1',
} as const;
